import ClipLoader from "react-spinners/ClipLoader";

export default function Blurred({ loading = false, toggled = false, children, fill = false, opacity = 0.3 }) {
    let style = { 
        opacity: toggled ? opacity : 1, 
        position: 'relative',
        width: fill ? '-webkit-fill-available' : '',
    }

    if (toggled) style.pointerEvents = 'none';
    
    return (
        <div style={style}>
            { toggled && <div style={{ position: 'absolute', left: '0%', top: '0%', width: '100%', height: '100%' }}></div> }
            { loading && <div style={{ position: 'absolute', display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%', zIndex: '10' }}>
                <ClipLoader
                    color={'black'}
                    loading={true}
                    override={{
                        borderWidth: '10px'
                    }}
                    size={150}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                />
            </div> }
            { children }
        </div>
    )
}